import { Outlet } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { useSidebar } from './contexts/SidebarContext';
import { ScrollToTop, mainContentRef } from './components/ScrollToTop';
import { cn } from './lib/utils';

function App() {
  const { expanded } = useSidebar();

  return (
    <div className="flex h-screen overflow-hidden bg-white font-sans">
      <ScrollToTop />
      <Sidebar />
      <main
        ref={(el) => { if (el) mainContentRef.current = el; }}
        className={cn('flex-1 overflow-y-auto transition-all duration-300', expanded ? 'ml-64' : 'ml-20')}
      >
        <div className="p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default App;
